import { useEffect } from 'react';
import { Platform } from 'react-native';

// Injects Organization + WebSite JSON-LD schemas globally.
// Mount once in the root layout.
export function OrganizationSchema() {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;

    const SITE_URL = 'https://kursiaii.com';

    const schemas = [
      // EducationalOrganization only — WebSite/Organization already rendered SSR in app/+html.tsx
      {
        '@context': 'https://schema.org',
        '@type': 'EducationalOrganization',
        '@id': `${SITE_URL}/#educational-organization`,
        name: 'Kursi',
        alternateName: 'קורסי',
        url: SITE_URL,
        logo: {
          '@type': 'ImageObject',
          url: `${SITE_URL}/logo.png`,
          width: 512,
          height: 512,
        },
        description: 'פלטפורמת הקורסים המובילה בישראל — התאמה אישית מבוססת AI לקורסים אונליין ופרונטליים',
        inLanguage: 'he',
        areaServed: {
          '@type': 'Country',
          name: 'Israel',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'Customer Service',
          availableLanguage: ['he'],
        },
        sameAs: ['https://www.instagram.com/kursi_il'],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'קטלוג קורסים',
          url: `${SITE_URL}/courses`,
        },
      },
    ];

    const injected: HTMLScriptElement[] = [];

    // Remove any previously injected site-level schemas
    document
      .querySelectorAll('script[data-kursi-site-schema]')
      .forEach((el) => el.remove());

    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-kursi-site-schema', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      injected.push(script);
    });

    return () => {
      injected.forEach((s) => {
        if (s.parentNode) s.parentNode.removeChild(s);
      });
    };
  }, []);

  return null;
}
